export const teamName: { [key: number]: string } = {
  1: "赤チーム",
  2: "青チーム",
  3: "緑チーム",
  4: "黄チーム",
};
